import { MainResponse } from '../../main-response.model';
import { XaItem } from './xa-item.model';

export class ListXaResponse extends MainResponse {
    object: XaItem[] = [];
     
    constructor(obj = null) {
        super();
        obj = obj || {};
        this.init(obj);
        this.object = [];
        if (obj.object && obj.object instanceof Array) {
            obj.object.forEach((item) => {
                this.object.push(new XaItem(item));
            })
        }
    }
}